<template>
  <div class="topbar">
<!--    <div class="toggle" ></div>-->
<!--    <div class="search">-->
<!--      <label>-->
<!--        <input type="text" placeholder="جستجو">-->
<!--        <i class="fa fa-search" aria-hidden="true"></i>-->
<!--      </label>-->
<!--    </div>-->

  </div>
</template>

<script>
export default {
  name: "topbar"
}
</script>

<style scoped>

</style>